import { useState, useEffect } from "react";
import Avvvatars from "avvvatars-react";
import { Link } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import { ParentDataTable } from "../../core/data/interface";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { toast } from "sonner";
// récupérer les liens
import { getAllTypeLink } from "../../api/studentParent";
// gérer les liens parents-enfants
import {
  deleteStudentParent,
  updateStudentParent,
} from "../../api/studentParent";
import { getStudentById } from "../../api/etudiants";
import { recoverAccount } from "../../api/users";
import { getParentById, getAllParents, deleteParent } from "../../api/parents";
import CreateParentModal from "./createParent";
import EditParentModal from "./editParent";

// pour restreindre l'accès à ce composant
import withPermission from "../../core/common/autorisations/withPermission";
import { getStudentArchivesById } from "../../api/archives";
import EditLinkRow from "./EditLinkRow";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import TooltipOption from "./tooltipOption";
import InfosAlertYearDisabled from "../../core/common/alerts/infosAlertYearDisabled";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import DashboardMenu from "../user/admin/dashboardMenu";

//  bouton protégé pour ajouter un parent
const ProtectedAddParent = withPermission(
  (props: any) => (
    <div className="mb-2">
      <Link
        to="#"
        className="btn btn-primary d-flex align-items-center"
        data-bs-toggle="modal"
        data-bs-target="#add_parent_modal"
        onClick={() => {}}
      >
        <i className="ti ti-square-rounded-plus me-2" />
        Nouveau Parent
      </Link>
    </div>
  ),
  [buildPermission(Resource.PARENT, Action.CREATE)],
  "masquer",
);

//  bouton protégée pour modifier un parent
const ProtectedUpdateParent = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item rounded-1"
        data-bs-toggle="modal"
        data-bs-target="#edit_parent_modal"
        // to={`/edit-user/${record.id}`}
        onClick={() => {
          props.setEditParent(
            props.allParents.find(
              (parent: any) => parent.id === props.record.id,
            ),
          );
        }}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier
      </button>
    </li>
  ),
  [buildPermission(Resource.PARENT, Action.UPDATE)],
  "masquer",
);

//  bouton protégée pour supprimer un parent
const ProtectedDeleteParent = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item rounded-1"
        onClick={() => props.showdeleteParentConfirmationAlert(props.record)}
        // data-bs-toggle="modal"
        // data-bs-target="#delete-modal"
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </button>
    </li>
  ),
  [buildPermission(Resource.PARENT, Action.DELETE)],
  "masquer",
);

// bouton pour réinitialiser un mot de passe
const ProtectedBtnResetPasword = withPermission(
  (props: any) => (
    <li>
      <button
        disabled={!props.record.email}
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
      >
        <i className="ti ti-menu me-2" />
        Mot de passe
      </button>
    </li>
  ),
  [buildPermission(Resource.PARENT, Action.UPDATE)],
  "masquer",
);

// bouton pour modifier un lien
const ProtectedBtnUpdateLink = withPermission(
  (props: any) => (
    <button
      className="dropdown-item"
      onClick={() => props.setEditChildId(props.child.id)}
    >
      Modifier Lien
    </button>
  ),
  [buildPermission(Resource.PARENT, Action.UPDATE)],
  "masquer",
);

// bouton pour supprimer un lien
const ProtectedBtnDeleteLink = withPermission(
  (props: any) => (
    <button
      className="dropdown-item"
      onClick={() => {
        props.showDeleteConfirmationAlert(props.child.studentParentId);
      }}
    >
      Supprimer Lien
    </button>
  ),
  [buildPermission(Resource.PARENT, Action.UPDATE)],
  "masquer",
);

const AllParent = () => {
  const routes = my_routes;
  const { selectedYear } = useAcademicYear();
  // Modal détails
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  //Initialisation des state utilisés
  const [allParents, setAllParents] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données
  const [editParent, setEditParent] = useState<any>(); // Les datas du parent à modifier
  const [updateData, setUpdateData] = useState(false); // Mettre à jour les modifications visuellement
  const [allLinks, setAllLinks] = useState<any>(); // les types de liens
  const [editChildId, setEditChildId] = useState<any>(); //id de l'enfant avec qui l'on veut changer le type de relation

  // le parent afficher dans le modal détails
  const [parentDetail, setParentDetail] = useState<any>(); // les datas du parent à afficher les détails
  const [childrenParentDetail, setChildrenParentDetail] = useState<any[]>([]); // liste des enfants du parent détaillé

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);
  //  sweet alert pour la modification du mot de passe
  const showConfirmationAlert = (parent: any) => {
    MySwal.fire({
      title: "Réinitialiser mot de passe ?",
      text: `Un e-mail contenant un lien sécurisé lui sera envoyé à ${parent.firstname} ${parent.lastname} pour lui permettre de définir un nouveau mot de passe.`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Réinitialisation en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await recoverAccount(parent.email);
          MySwal.fire({
            title: "Lien envoyé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de l'envoi de l'e-mail. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //  sweet alert pour la suppresion de lien
  const showDeleteConfirmationAlert = (relation_id: string) => {
    MySwal.fire({
      title: "Supprimer lien ?",
      text: `Voulez-vous vraiment supprimer le lien de ${parentDetail.firstname} ${parentDetail.lastname} ?`,
      showCancelButton: true,
      confirmButtonText: "Supprimer!",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });

        try {
          //On lance la requête de suppression
          await deleteStudentParent(relation_id);
          MySwal.fire({
            title: "Lien supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          setChildrenParentDetail((prev) =>
            prev.filter((child) => child.studentParentId !== relation_id),
          );
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de la suppression du lien. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };
  // alert pour supprimer un parent
  const showdeleteParentConfirmationAlert = (parent: any) => {
    MySwal.fire({
      title: "Supprimer parent ?",
      text: `Voulez-vous vraiment supprimer ${parent.firstname} ${parent.lastname} ?`,
      showCancelButton: true,
      confirmButtonText: "Supprimer!",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });

        try {
          //On lance la requête de suppression
          await deleteParent(parent.id);
          MySwal.fire({
            title: "Parent supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          setAllParents((prev) =>
            prev.filter((parentItem) => parentItem.id !== parent.id),
          );
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de la suppression du parent. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // on récupère la liste des liens existant dans la base de donnée
  const getAllLink = async () => {
    try {
      const response = await getAllTypeLink(
        buildPermissionContext(Resource.PARENT, Action.READ),
      );
      setAllLinks(response.data);
    } catch (error) {
      // console.error(
      //   "Erreur lors de la récupération des types de liens:",
      //   error
      // );
      toast.error("Erreur lors de la récupération des types de liens");
    }
  };

  // Fonction pour changer le lien
  const handleSaveLinkChange = async (childId: string, newLinkId: string) => {
    try {
      // Tu peux ajouter un appel API ici si besoin
      // await updateStudentParentRelation(childId, newLinkId);
      await updateStudentParent(childId, { id_link: newLinkId });
      const updatedLinkType = allLinks.find(
        (l: any) => l.id === newLinkId,
      )?.type;

      setChildrenParentDetail((prev) =>
        prev.map((child) =>
          child.studentParentId === childId
            ? {
                ...child,
                link: {
                  ...child.link,
                  id: newLinkId,
                  type: updatedLinkType,
                },
              }
            : child,
        ),
      );

      toast.success("Lien mis à jour !");
      setEditChildId(null);
    } catch (error) {
      // console.error("Erreur lors de la mise à jour :", error);
      toast.error("Échec de la mise à jour du lien.");
    }
  };

  // onrécupère la liste des liens (relations)
  useEffect(() => {
    getAllLink();
  }, []);

  const fetchAllParent = () => {
    getAllParents()
      .then((parents) => {
        // console.log(parents);
        setAllParents(parents.data);
      })

      .catch((error: any) => {
        // console.error("Erreur lors de la récupération des parents:", error);
      })
      .finally(() => {
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
        setUpdateData(false); // les données ont été mise à jour !
      });
  };
  //On recupère la liste des Parents en appelant sa fonction
  useEffect(() => {
    fetchAllParent();
  }, [updateData]);

  const getChildStudentInfo = async (id_child: string) => {
    try {
      const student = await getStudentById(
        id_child,
        buildPermissionContext(Resource.PARENT, Action.READ),
      );
      const studentArchive = await getStudentArchivesById(
        id_child,
        buildPermissionContext(Resource.PARENT, Action.READ),
      );
      if (!selectedYear) return;
      // console.log("arch student: ",studentArchive)
      const studentArchData = studentArchive.data.find(
        (archiveItem: any) => archiveItem?.id_academicYear === selectedYear.id,
      );
      if (studentArchData) {
        const formattedData = selectedYear
          ? {
              ...student.data,
              class: studentArchData?.Class,
              academicYear: studentArchData?.AcademicYear,
              id_academicYear: studentArchData?.id_academicYear,
            }
          : { ...student.data };
        // console.log("est inscrit: ", formattedData);
        // setStudentData(formattedData);
        return formattedData;
      } else {
        const formattedData = {
          ...student.data,
          class: studentArchive.data[studentArchive?.data.length - 1]?.Class,
          academicYear:
            studentArchive.data[studentArchive?.data.length - 1]?.AcademicYear,
          id_academicYear:
            studentArchive.data[studentArchive?.data.length - 1]
              ?.id_academicYear,
        };
        // console.log("non inscript", formattedData);
        return formattedData;
      }
    } catch (error: any) {
      // console.error(
      //   "Erreur lors de la récupération des infos étudiant de l'enfant:",
      //   error
      // );
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
        
    }
  };

  // on récupère la liste des enfants du ParentDetail
  const getParentChildren = async (id: string) => {
    try {
      const response = await getParentById(id);
      // console.log("Enfants du parent: ", response.data);
      // setChildrenParentDetail(response.data.children);
      const children = response.data.children;
      if (children) {
        const childrenStudentInfo = await Promise.all(
          children.map(async (child: any) => {
            const studentInfo = await getChildStudentInfo(child.id);
            return {
              ...child,
              statut: studentInfo?.statut,
              sexe: studentInfo?.sexe,
              class: studentInfo?.class,
              academicYear: studentInfo?.academicYear,
              id_academicYear: studentInfo?.id_academicYear,
            };
          }),
        );
        console.log("infos child final: ", childrenStudentInfo);
        setChildrenParentDetail(childrenStudentInfo);
      } else {
        setChildrenParentDetail([]);
      }
    } catch (error: any) {
      // console.log(
      //   "Erreur lors de la récupération des enfants du parents: ",
      //   error
      // );
      toast.error(
        error.message ||
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Les colonnes de notre tableau
  const columns = [
    {
      title: "Prénom",
      dataIndex: "firstname",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to="#"
                onClick={async () => {
                  await getParentChildren(record.id);
                  setParentDetail(
                    allParents.find((parent) => parent.id === record.id),
                  );
                  setShow(true);
                }}
              >
                {text}
              </Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: ParentDataTable, b: ParentDataTable) =>
        a.firstname.length - b.firstname.length,
    },
    {
      title: "Nom",
      dataIndex: "lastname",
      sorter: (a: ParentDataTable, b: ParentDataTable) =>
        a.firstname.length - b.firstname.length,
    },
    {
      title: "Sexe",
      dataIndex: "sexe",
      sorter: (a: ParentDataTable, b: ParentDataTable) =>
        a.sexe.length - b.sexe.length,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a: ParentDataTable, b: ParentDataTable) =>
        a?.email?.length - b?.email?.length,
    },
    {
      title: "Téléphone",
      dataIndex: "number",
      sorter: (a: ParentDataTable, b: ParentDataTable) =>
        a?.number?.length - b?.number?.length,
    },
    {
      title: "Statut",
      dataIndex: "statut",
      render: (text: boolean) => (
        <>
          {text === true ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Actif
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Inactif
            </span>
          )}
        </>
      ),
      sorter: (a: ParentDataTable, b: ParentDataTable) =>
        a.statut === b.statut ? 0 : a.statut ? -1 : 1,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <div className="dropdown">
                <Link
                  to="#"
                  className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="ti ti-dots-vertical fs-14" />
                </Link>
                <ul className="dropdown-menu dropdown-menu-right p-3">
                  <li>
                    <Link
                      className="dropdown-item rounded-1"
                      to="#"
                      onClick={async () => {
                        await getParentChildren(record.id);
                        setParentDetail(
                          allParents.find((parent) => parent.id === record.id),
                        );
                        setShow(true);
                      }}
                    >
                      <i className="ti ti-menu me-2" />
                      Détails Parent
                    </Link>
                  </li>
                  {/* modifier un parent */}
                  <ProtectedUpdateParent
                    setEditParent={setEditParent}
                    allParents={allParents}
                    record={record}
                  />
                  {/* réinitialiser mot de passe */}
                  <ProtectedBtnResetPasword
                    showConfirmationAlert={showConfirmationAlert}
                    record={record}
                  />
                  {/* supprimer parent */}
                  <ProtectedDeleteParent
                    showdeleteParentConfirmationAlert={
                      showdeleteParentConfirmationAlert
                    }
                    record={record}
                  />
                </ul>
              </div>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <DashboardMenu />
            {/* Boutton en entête de la page */}
            <div className="d-flex my-xl-auto right-content align-items-center">
              <TooltipOption updateData={fetchAllParent} />
              <ProtectedAddParent />
            </div>
          </div>
          {/* /Page Header */}
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          {/* Tableau liste des parents */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Liste des Parents</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  {/* <PredefinedDateRanges /> */}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Staffs List (On affiche le tableau qui si les données son chargées même vide) */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={allParents}
                  Selection={true}
                />
              )}
              {/* /Staffs List */}
            </div>
          </div>
        </div>
      </div>
      {/* / Page Wrapper */}

      {/* Modal d'ajout */}
      <CreateParentModal
        setAllParents={setAllParents}
        updateData={setUpdateData}
      />
      <EditParentModal
        setAllParents={setAllParents}
        parent={editParent}
        updateData={setUpdateData}
      />

      {/* Modal Détails Parents */}

      <Modal show={show} onHide={handleClose} centered size="lg">
        <div className="modal-header">
          <h4 className="modal-title">Details Parent</h4>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        {parentDetail && childrenParentDetail ? (
          <div className="modal-body mb-0">
            <div className="parent-wrap">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="d-flex align-items-center mb-3">
                    <span className="avatar avatar-xl me-2">
                      <Avvvatars
                        value={`${parentDetail.firstname?.charAt(0) || ""}${
                          parentDetail.lastname?.charAt(0) || ""
                        }`}
                        style="character" // ou "character"
                        size={60}
                      />
                    </span>
                    <div className="parent-name">
                      <h5 className="mb-1">
                        {parentDetail.firstname} {parentDetail.lastname}
                      </h5>
                      <p>
                        Ajouté le{" "}
                        {new Date(parentDetail.createdAt).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          },
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <ul className="d-flex flex-wrap align-items-start gap-4">
                    <li className="mb-3 me-5">
                      <p className="mb-1">Email</p>
                      <h6 className="fw-normal">{parentDetail.email}</h6>
                    </li>
                    <li className="mb-3 me-5">
                      <p className="mb-1">Phone</p>
                      <h6 className="fw-normal">{parentDetail.number}</h6>
                    </li>
                    <li className="mb-3">
                      <p className="mb-1">Adresse</p>
                      <h6 className="fw-normal">{parentDetail.adresse}</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <h5 className="mb-3">
              Details Enfants ({childrenParentDetail.length})
            </h5>
            {childrenParentDetail.map((child) => (
              <div className="border rounded p-4 pb-1 mb-3" key={child.id}>
                <div className="d-flex align-items-center justify-content-between flex-wrap pb-1 mb-3 border-bottom gap-2">
                  <div className="d-flex flex-column">
                    <span className="link-primary text-truncate">
                      {`${child?.academicYear?.label || ""}`}
                    </span>
                    <span className="fs-12">
                      {`${
                        child?.class?.Level
                          ? " " + child?.class?.Level?.label
                          : ""
                      } - ${
                        child?.class ? " " + child?.class?.label : "aucun"
                      }`}
                    </span>
                  </div>
                  {child?.id_academicYear === selectedYear?.id ? (
                    <span className="badge badge-soft-success badge-md mb-2">
                      <i className="ti ti-circle-filled me-2" />
                      Actif
                    </span>
                  ) : (
                    <span className="badge badge-soft-danger badge-md mb-2">
                      <i className="ti ti-circle-filled me-2" />
                      Inactif
                    </span>
                  )}

                  <div className="dropdown">
                    <Link
                      to="#"
                      // className="dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="ti ti-dots-vertical fs-14" />
                    </Link>
                    <div className="dropdown-menu dropdown-menu-end">
                      {/* redirige vers la page de détails de l'etudiant */}
                      <Link
                        to={`/student-detail/${child.id}`}
                        className="dropdown-item"
                      >
                        Voir Details
                      </Link>
                      {/* modifier un lien */}
                      <ProtectedBtnUpdateLink
                        setEditChildId={setEditChildId}
                        child={child}
                      />

                      {/* supprimer un lien */}
                      <ProtectedBtnDeleteLink
                        showDeleteConfirmationAlert={
                          showDeleteConfirmationAlert
                        }
                        child={child}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div className="d-flex align-items-center mb-3">
                    {/* doit diriger vers la page de détails de l'enfant sélectionnées(doit changer le chemin: studentDetail) */}
                    <Link to={routes.studentDetailsPage} className="avatar">
                      <Avvvatars
                        value={`${child.firstname?.charAt(0) || ""}${
                          child.lastname?.charAt(0) || ""
                        }`}
                        style="character" // ou "character"
                        size={40}
                      />
                    </Link>
                    <div className="ms-2">
                      <p className="mb-0">
                        {/* <Link to={routes.studentDetail}>Janet</Link> */}
                        {child.firstname} {child.lastname}
                      </p>
                      <span className="fs-12">{child?.matricule}</span>
                    </div>
                  </div>
                  <ul className="d-flex align-items-center flex-wrap">
                    {editChildId === child.id && (
                      <EditLinkRow
                        child={child}
                        allLinks={allLinks}
                        onSave={handleSaveLinkChange}
                        onCancel={() => setEditChildId(null)}
                      />
                    )}

                    <li className="mb-3 me-4">
                      <p className="mb-1">Type lien</p>
                      <h6 className="fw-normal">{child.link.type}</h6>
                    </li>
                    <li className="mb-3 me-4">
                      <p className="mb-1">Genre</p>
                      <h6 className="fw-normal">{child.sexe}</h6>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div>
            <p>chargement ...</p>
          </div>
        )}
      </Modal>
    </>
  );
};
export default AllParent;
